import axios from 'axios'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' }
})

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token') ?? sessionStorage.getItem('token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

api.interceptors.response.use(
  response => response,
  error => {
    const status = error.response?.status
    const isAuthEndpoint = (error.config?.url ?? '').includes('/auth/')
    if (status === 401 && !isAuthEndpoint) {
      Promise.all([import('@/stores/auth'), import('@/router')]).then(([{ useAuthStore }, { default: router }]) => {
        useAuthStore().logout()
        if (router.currentRoute.value.name !== 'Login') router.push('/login')
      })
    }
    if (status === 429) {
      error.isRateLimited = true
      error.retryAfter = error.response.headers['retry-after'] ?? 60
    }
    return Promise.reject(error)
  }
)

export default api
